export default __webpack_public_path__ + "static/media/sample-article.42e39547.htm";